import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import {
  IArquivoItemModel,
  IArquivoRespostaModel,
  IItemSolicitacaoTecnicaModel, IRepostaItemModel
} from "../../../../../models/item-solicitacao-tecnica.model";
import { INotaItemAuditoriaExecucaoModel } from "../../../../../models/nota-item-auditoria-execucao.model";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { NotaAuditoriaExecucaoService } from "../../../../../services/nota-auditoria-execucao.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import Swal from "sweetalert2";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { ModalCancelarComponent } from "../../../../../shared/components/modal-cancelar/modal-cancelar-component";

@Component({
  selector: 'app-modal-responder-item-nota-aduditoria',
  templateUrl: './modal-responder-item-nota-auditoria-execucao.componet.html',
  styleUrls: ['./modal-responder-item-nota-auditoria-execucao.componet.scss']
})
export class ModalResponderItemNotaAuditoriaExecucaoComponent implements OnInit {
  public dataSource = new MatTableDataSource<IArquivoItemModel>([]);
  public dataSourceResposta = new MatTableDataSource<IArquivoRespostaModel>([]);
  public semDados: boolean = false;
  public model: INotaItemAuditoriaExecucaoModel = {} as INotaItemAuditoriaExecucaoModel;

  public responder = false;
  public tituloModal = "";
  public submitted = false;

  public notaAuditoriaExecucaoId: number;
  public numeroNota: string;

  // ✅ Variáveis dos campos readonly
  public numeroConstacacao: number;
  public numeroOsa: string = "";
  public nNotaAuditoriaExecucao: string = "";
  public nomeResponsavel: string = "";
  public statusDescricao: string = "";
  public avaliacaoDescricao: string = "";

  public respostaItemModel: IRepostaItemModel = {} as IRepostaItemModel;

  public visualizar = false;
  public acceptTypes: string = `
                                image/png,
                                image/jpeg,
                                application/pdf,
                                application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                video/mp4
                              `.replace(/\s/g, '');

  maxFileSizeMB: number = 28;

  @ViewChild("tabelaItemPaginator", { static: true })
  tabelaItemPaginator: MatPaginator;
  @ViewChild("tabelaItemSort", { static: true }) tabelaItemSort: MatSort;

  @ViewChild("tabelaRespostaPaginator", { static: true })
  tabelaRespostaPaginator: MatPaginator;
  @ViewChild("tabelaRespostaSort", { static: true })
  tabelaRespostaSort: MatSort;

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "10rem",
    minHeight: "5rem",
    translate: "yes",
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: "",
    defaultFontName: "",
    defaultFontSize: "",
    fonts: [
      { class: "arial", name: "Arial" },
      { class: "times-new-roman", name: "Times New Roman" },
      { class: "calibri", name: "Calibri" },
      { class: "comic-sans-ms", name: "Comic Sans MS" },
    ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    uploadUrl: "v1/image",
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: "top",
    toolbarHiddenButtons: [["bold", "italic"], ["fontSize"]],
  };

  public editorMaxLength = 2000;

  constructor(
    public matDialog: MatDialog,
    private dialogRef: MatDialogRef<ModalResponderItemNotaAuditoriaExecucaoComponent>,
    public notaAuditoriaExecucaoService: NotaAuditoriaExecucaoService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.model.id = data?.id;
    this.notaAuditoriaExecucaoId = data?.notaAuditoriaExecucaoId;
    this.responder = data?.responder;
    this.numeroNota = data?.numeroNotaAuditoria;
    this.visualizar = data?.visualizar;

    // ✅ Populando as variáveis dos campos readonly do data
    this.numeroConstacacao = data?.numeroAuditoriaConstacao;
    this.numeroOsa = data?.documentoAssociado || "";
    this.nNotaAuditoriaExecucao = data?.numeroNotaAuditoria || "";
    this.nomeResponsavel = data?.resposavel || "";
    this.statusDescricao = data?.element?.status?.descricao || "-";
    this.avaliacaoDescricao = data?.element?.statusAvaliacao?.descricao || "-";
  }

  onEditorChange(content: string) {
    if (content && content.length > this.editorMaxLength) {
      this.respostaItemModel.descricao = content.substring(0, this.editorMaxLength);
    }
  }

  ngOnInit(): void {
    if (this.responder) this.tituloModal = "Responder Constatação Nota de Auditoria";
    else this.tituloModal = "Visualizar Resposta Constatação Nota de Auditoria";

    this.obterPorId();

    this.dataSource.paginator = this.tabelaItemPaginator;
    this.dataSource.sort = this.tabelaItemSort;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;

    this.dataSourceResposta.sortingDataAccessor = this.sortingDataAccessor;
    this.dataSourceResposta.sort = this.tabelaRespostaSort;
    this.dataSourceResposta.paginator = this.tabelaRespostaPaginator;
  }

  public obterPorId() {
    this.notaAuditoriaExecucaoService
      .obterItemId(this.notaAuditoriaExecucaoId, this.model?.id)
      .then((res) => {
        if (res.sucesso) {
          this.model = res.dados;
          this.model = res.dados;
          this.numeroConstacacao = res.dados.numero ? parseInt(res.dados.numero) : this.numeroConstacacao;

          this.dataSource.data = res?.dados?.anexo;
          this.dataSource.paginator = this.tabelaItemPaginator;
          this.dataSource.sort = this.tabelaItemSort;
          this.dataSource.sortingDataAccessor = this.sortingDataAccessor;

          if (res?.dados?.respostaItemAuditoriaExecucao) {
            this.respostaItemModel = res?.dados?.respostaItemAuditoriaExecucao;
          }

          if (res?.dados?.respostaItemAuditoriaExecucao?.anexos) {
            this.dataSourceResposta.data = res?.dados?.respostaItemAuditoriaExecucao?.anexos;
          }
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "arquivo":
        return item.nomeArquivo;
      default:
        return item[property];
    }
  };

  public salvar(fechar: boolean) {
    this.submitted = true;

    if (!this.respostaItemModel.descricao || this.respostaItemModel.descricao.trim() === '') {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Informe a descrição da resposta!",
      });
      return;
    }

    if (!this.dataSourceResposta?.data || this.dataSourceResposta.data.length === 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Anexe pelo menos um arquivo na resposta!",
      });
      return;
    }

    this.respostaItemModel.anexos = this.dataSourceResposta?.data;

    this.notaAuditoriaExecucaoService
      .salvarItemResposta(this.model.id, this.respostaItemModel)
      .then((res) => {
        if (res.sucesso) {
          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            icon: "success",
            text: res.mensagem.descricao,
          });

          if (fechar) {
            this.dialogRef.close(true);
          } else {
            this.obterPorId();
          }
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public async anexarArquivosResposta(e: any) {
    const files = (e.target as HTMLInputElement).files;
    if (!files || files.length === 0) return;

    const flatListFiles = Array.from(files);

    for (let i = 0; i < flatListFiles.length; i++) {
      const file = flatListFiles[i];

      const tipo = file.type.toUpperCase();
      const sizeMB = Math.trunc(file.size / 1024 / 1024);

      // Validação de tipo (PDF, PNG, JPG, XLSX e/ou MP4)
      if (tipo.includes("PDF") == false
        && tipo.includes("PNG") == false
        && tipo.includes("JPG") == false
        && tipo.includes("JPEG") == false
        && tipo.includes("MP4") == false
        && tipo.includes("EXCEL") == false
        && tipo.includes("VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET") == false) {
        alert("O formato do arquivo deve ser PDF, PNG, JPG, XLSX e/ou MP4");
        continue;
      }

      // Validação de tamanho específica para MP4
      if (tipo.includes("MP4")) {
        if (sizeMB > 28) {
          alert("Não é permitido videos com mais de 28Mb");
          continue;
        }
      }
      else if (sizeMB > 28) {
        alert("Não é permitido arquivos com mais de 28Mb");
        continue;
      }

      const fileToArray = await this.getBase64(file);
      this.dataSourceResposta.data.push({
        id: 0,
        nomeArquivo: file.name,
        arquivo: fileToArray.toString(),
      });
    }

    this.dataSourceResposta.sortingDataAccessor = this.sortingDataAccessor;
    this.dataSourceResposta.sort = this.tabelaRespostaSort;
    this.dataSourceResposta.paginator = this.tabelaRespostaPaginator;
  }

  public getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: "Ocorreu um erro ao selecionar o arquivo" + error.toString(),
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
        reject(error);
      };
    });
  }

  public DownloadResposta(arquivo: IArquivoRespostaModel) {
    this.notaAuditoriaExecucaoService.downloadArquivoRespostaItem(arquivo).then((res) =>{
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.toString();
        link.download = arquivo.nomeArquivo;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }})
  }

  public Download(arquivo: IArquivoRespostaModel) {
    // Implementar download do arquivo de resposta
    this.notaAuditoriaExecucaoService.downloadAnexo(this.model.id, arquivo.id).then((res) => {
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.toString();
        link.download = arquivo.nomeArquivo;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }

  public async removerArquivoItemResposta(arquivo: IArquivoRespostaModel) {
    Swal.fire({
      title: "Excluir Registro",
      text: "Tem certeza que deseja excluir esse Registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        if (arquivo.id > 0) {
          this.notaAuditoriaExecucaoService
            .excluirAnexoItemResposta(arquivo)
            .then((res) => {
              if (res.sucesso) {
                let index = this.dataSourceResposta.data.indexOf(arquivo);
                this.dataSourceResposta.data.splice(index, 1);

                this.dataSourceResposta.sortingDataAccessor = this.sortingDataAccessor;
                this.dataSourceResposta.sort = this.tabelaRespostaSort;
                this.dataSourceResposta.paginator = this.tabelaRespostaPaginator;
              } else {
                Swal.fire({
                  toast: true,
                  position: "top-end",
                  icon: "warning",
                  text: res.mensagem.descricao,
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                });
              }
            });
        } else {
          let index = this.dataSourceResposta.data.indexOf(arquivo);
          this.dataSourceResposta.data.splice(index, 1);

          this.dataSourceResposta.sortingDataAccessor = this.sortingDataAccessor;
          this.dataSourceResposta.sort = this.tabelaRespostaSort;
          this.dataSourceResposta.paginator = this.tabelaRespostaPaginator;
        }
      }
    });
  }

  public cancelar() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      interno: true,
      fecharApenasPropria: true
    };

    if (this.visualizar) {
      this.dialogRef.close();
    } else {
      const modalCancelar = this.matDialog.open(ModalCancelarComponent, dialogConfig);

      modalCancelar.afterClosed().subscribe((confirmado) => {
        if (confirmado === true) {
          this.dialogRef.close(false);
        }
      });
    }
  }
}
